import { datadogLogs } from '@datadog/browser-logs';
import { analyticsStore } from './sendAnalytics';

const { logger } = datadogLogs;

const originalLogFn = datadogLogs.logger.log;
let datadogLogsQueue: Parameters<typeof originalLogFn>[] = [];

datadogLogs.logger.log = (...args) => {
  const { datadogEnabled } = analyticsStore.getState();

  if (datadogEnabled) {
    originalLogFn.apply(logger, args);
    datadogLogsQueue.forEach((logData) => originalLogFn.apply(logger, logData));
    datadogLogsQueue = [];
  } else {
    datadogLogsQueue.push(args);
  }
};
